import { useState, useEffect, useCallback } from "react";
import { useAuth } from "../../../components/context/LoginContext/AuthContext";

/**
 * @typedef {Object} InvoiceDetail
 * @property {number} id
 * @property {string} tenant_id
 * @property {number} institution_id
 * @property {string} invoice_number
 * @property {string} amount
 * @property {string} method
 * @property {string} status
 * @property {string} created_at
 * @property {string} updated_at
 * // Add more fields returned by your API
 */

/**
 * Hook to fetch a single invoice detail by id
 *
 * @param {number|string} invoiceId
 * @returns {{
 *  invoice: InvoiceDetail | null,
 *  loading: boolean,
 *  error: string | null,
 *  refetch: () => void
 * }}
 */
export const useGetInvoice = (invoiceId) => {
  const { user, fetchWithAuth } = useAuth();
  const apiUrl = process.env.REACT_APP_API_URL;

  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  console.log("Invoid Id IS " + invoiceId)

  const fetchInvoice = useCallback(async () => {
    if (!invoiceId || !user?.token) return;

    setLoading(true);
    setError(null);

    try {
      const response = await fetchWithAuth(
        `${apiUrl}/school/invoices/${invoiceId}`,
        { method: "GET" },
      );

      if (!response.ok) {
        throw new Error("Failed to fetch invoice");
      }

      const result = await response.json();

      if (!result.success) {
        throw new Error(result.message || "Failed to fetch invoice");
      }

      setInvoice(result.data || null);
    } catch (err) {
      console.error("Invoice Fetch Error:", err);
      setError(err.message || "Something went wrong");
      setInvoice(null);
    } finally {
      setLoading(false);
    }
  }, [invoiceId, apiUrl, fetchWithAuth, user]);

  useEffect(() => {
    console.log("Invoid Id inside Effect " + invoiceId)
    fetchInvoice();
  }, [invoiceId, fetchInvoice]);

  return { invoice, loading, error, refetch: fetchInvoice };
};
